// Company Information
export const COMPANY = {
  name: 'MachineAI',
  fullName: 'MachineAI Việt Nam',
  tagline: 'Giải Pháp AI Tiên Tiến',
  description: 'Công ty công nghệ tập trung vào các giải pháp Edge AI, AI công nghiệp, hệ thống nhúng và tự động hóa cho doanh nghiệp và nhà máy.',
  founded: 2020,
} as const;

// Contact Information
export const CONTACT = {
  phone: '0886-967-375',
  email: 'contact@machineai.vn',
  address: 'Thành phố Hồ Chí Minh, Việt Nam',
} as const;

// Social Media Links
export const SOCIAL_LINKS = {
  facebook: 'https://facebook.com/machineai',
  linkedin: 'https://linkedin.com/company/machineai',
  youtube: 'https://youtube.com/@machineai',
  twitter: 'https://twitter.com/machineai',
} as const;

// Navigation Links
export const NAV_LINKS = [
  { href: '/', label: 'Trang Chủ' },
  { href: '/about', label: 'Giới Thiệu' },
  { href: '/san-pham', label: 'Sản Phẩm' },
  { href: '/dich-vus', label: 'Giải Pháp' },
  { href: '/projects', label: 'Dự Án' },
] as const;

// Stats for homepage and about page
export const STATS = [
  { label: 'Doanh Nghiệp Phục Vụ', value: '500+' },
  { label: 'Dự Án Triển Khai', value: '50+' },
  { label: 'Tính Khả Dụng', value: '99.9%' },
] as const;

// CDN Base URL
export const CDN_URL = 'https://cdn.machineai.vn';

// Default images
export const DEFAULT_IMAGES = {
  hero: `${CDN_URL}/machineai_0c9e2156ad.png`,
  placeholder: `${CDN_URL}/machineai_0c9e2156ad.png`,
  logo: '/logo.png',
} as const;
